/**
 * Centralized admin email allowlist for the React frontend.
 *
 * Adding or removing an admin requires editing this constant, the matching
 * backend Set in website/src/admin.ts, and the rules files (firestore.rules
 * and storage.rules). Long-term migration to a Firebase custom claim is
 * tracked as audit finding F49.
 */
export const ADMIN_EMAILS = [
  'scott@advantagehorsemanship.com',
  'allie@advantagehorsemanship.com',
] as const

/**
 * Case-insensitive admin allowlist check. Defends against case mismatch if
 * Firebase Auth ever returns a mixed-case email.
 */
export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false
  return (ADMIN_EMAILS as readonly string[]).includes(email.toLowerCase())
}
